import React from "react";

import AssessmentIcon from "@mui/icons-material/Assessment";

function ReportIcon({ iconColor, iconSize = "small", ...other }) {
    return <AssessmentIcon color={iconColor} fontSize={iconSize} {...other} />;
}

export default ReportIcon;
